import { QueryFunctionContext } from '@tanstack/react-query';

import { baseQuery } from '../baseQuery';
import { type JsonDataItem } from 'types';

export const getSubscription = async ({ queryKey }: QueryFunctionContext<[string, number | undefined]>) => {
  const subscriptionId = queryKey[1];

  const { data }: { data: JsonDataItem } = await baseQuery(`subscriptions/${subscriptionId}`);

  return data;
};
